const SUB_CATEGORY_DISPLAY_LABELS: Record<string, string> = {
  EAP: 'Expanded Access Program (EAP)',
  'Not EAP': 'Not Expanded Access Program (EAP)',
};

export function subCategoryDisplayLabel(value: string): string {
  return SUB_CATEGORY_DISPLAY_LABELS[value] ?? value;
}
